import { render, staticRenderFns } from "./MerchantRelateContractDialog.vue?vue&type=template&id=d84aaa22&scoped=true"
import script from "./MerchantRelateContractDialog.vue?vue&type=script&lang=js"
export * from "./MerchantRelateContractDialog.vue?vue&type=script&lang=js"
import style0 from "./MerchantRelateContractDialog.vue?vue&type=style&index=0&id=d84aaa22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84aaa22",
  null
  
)

export default component.exports